var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-list',{attrs:{"title":"Вебинары","breadcrumbs":_vm.breadcrumbs,"folder-config":_vm.folderConfig,"data-source":_vm.dataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }